import { SB, createActions, action } from "@play-co/replicant";
const storageAdapterState = {
  gcinstant: SB.object({ platformStorage: SB.map(SB.unknown()) })
};
SB.object(storageAdapterState);
const storageAdapterActions = createActions(
  SB.object(storageAdapterState)
)({
  internalSetPlatformStorage: action((state, args) => {
    state.gcinstant.platformStorage = args;
  })
});
function createStorageAdapter(getReplicant) {
  const storageAdapter = {
    load: async () => {
      return getReplicant().state.gcinstant.platformStorage;
    },
    save: async (data) => {
      const replicant = getReplicant();
      void replicant.invoke.internalSetPlatformStorage(data);
      await replicant.flush();
    }
  };
  return storageAdapter;
}
export {
  createStorageAdapter,
  storageAdapterActions,
  storageAdapterState
};
